import { createFileRoute } from '@tanstack/react-router';
import { InscriptionGate } from '@/features/subscription/shared/InscriptionGate';
import InscriptionReviewPage from '@/features/subscription/inscription-review-page/InscriptionReviewPage';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

export const Route = createFileRoute('/vagas/$jobId_/inscricao/revisao')({
  component: () => (
    <InscriptionGate>
      <InscriptionReviewPage />
    </InscriptionGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
